import * as env from './env';

export const API_URL = env.dev;